// This source code is in the public domain.
// You may use, share, modify it freely,
// without any conditions or restrictions.
// https://simplycalc.com/luhn-source.php
function luhnChecksum(code) {
  const len = code.length;
  const parity = len % 2;
  let sum = 0;
  // eslint-disable-next-line no-plusplus
  for (let i = len - 1; i >= 0; i--) {
    // eslint-disable-next-line radix
    let d = parseInt(code.charAt(i));
    // eslint-disable-next-line eqeqeq
    if (i % 2 == parity) { d *= 2; }
    if (d > 9) { d -= 9; }
    sum += d;
  }
  return sum % 10;
}

/* luhnValidate
* Return true if specified code (with check digit) is valid.
*/
function luhnValidate(fullcode) {
  // eslint-disable-next-line eqeqeq
  return luhnChecksum(fullcode) == 0;
}

const validateCardNumber = (ccNumber) => luhnValidate(ccNumber);

export default validateCardNumber;
